import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Checkbox, Form, Input, Modal, Tooltip } from 'antd';
import React, { useState } from 'react';

export type StatusModalProps = {
  open: boolean;
  onCancel: () => void;
  /** Resolves once the page has created the column (or the store has reported a failure). */
  onCreate: (name: string, isFinalStatus: boolean) => Promise<void>;
  t: (key: string) => string;
};

const StatusModal: React.FC<StatusModalProps> = ({ open, onCancel, onCreate, t }) => {
  const [name, setName] = useState('');
  const [isFinalStatus, setIsFinalStatus] = useState(false);

  const close = () => {
    setName('');
    setIsFinalStatus(false);
    onCancel();
  };

  const create = async () => {
    if (!name.trim()) return;
    await onCreate(name.trim(), isFinalStatus);
    setName('');
    setIsFinalStatus(false);
  };

  return (
    <Modal
      title={t('AddStatus')}
      open={open}
      onCancel={close}
      className="add-status-modal"
      footer={[
        <Button key="cancel" onClick={close} className="hover-effect">
          {t('Cancel')}
        </Button>,
        <Button
          key="add"
          type="primary"
          onClick={() => {
            void create();
          }}
          disabled={!name.trim()}
          className="hover-effect"
        >
          {t('Add')}
        </Button>,
      ]}
    >
      <Form layout="vertical" className="add-status-form">
        <Form.Item label={t('StatusName')}>
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t('EnterStatusName')}
            autoFocus
            className="hover-effect"
          />
        </Form.Item>

        <Form.Item>
          <Checkbox checked={isFinalStatus} onChange={(e) => setIsFinalStatus(e.target.checked)}>
            {t('IsFinalStatus')}
            <Tooltip title={t('FinalStatusTooltip')}>
              <Button type="text" icon={<InfoCircleOutlined />} style={{ padding: 0, marginLeft: 4 }} />
            </Tooltip>
          </Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default StatusModal;
